/*  src/redux/auth/constants.ts
   ──────────────────────────────────────────────────── */

export enum AuthActionTypes {
  /* respuestas genéricas de la API */
  API_RESPONSE_SUCCESS        = '@auth/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR          = '@auth/API_RESPONSE_ERROR',

  /* login / logout / registro */
  LOGIN_USER                  = '@auth/LOGIN_USER',
  LOGOUT_USER                 = '@auth/LOGOUT_USER',
  SIGNUP_USER                 = '@auth/SIGNUP_USER',
  SIGNUP_USER_SUCCESS         = '@auth/SIGNUP_USER_SUCCESS',   // 🆕

  /* forgot-password */
  FORGOT_PASSWORD_REQUEST     = '@auth/FORGOT_PASSWORD_REQUEST', // 🆕
  FORGOT_PASSWORD_SUCCESS     = '@auth/FORGOT_PASSWORD_SUCCESS', // 🆕
  FORGOT_PASSWORD_ERROR       = '@auth/FORGOT_PASSWORD_ERROR',   // 🆕

  /* compatibilidad con código antiguo */
  FORGOT_PASSWORD             = '@auth/FORGOT_PASSWORD',
  FORGOT_PASSWORD_CHANGE      = '@auth/FORGOT_PASSWORD_CHANGE',

  /* Google login */
  LOGIN_USER_WITH_GOOGLE           = '@auth/LOGIN_USER_WITH_GOOGLE',
  LOGIN_USER_WITH_GOOGLE_SUCCESS   = '@auth/LOGIN_USER_WITH_GOOGLE_SUCCESS',
  LOGIN_USER_WITH_GOOGLE_FAILURE   = '@auth/LOGIN_USER_WITH_GOOGLE_FAILURE',

  /* varios */
  RESTORE_SESSION             = '@auth/RESTORE_SESSION',
  RESET                       = '@auth/RESET',
  SET_PARENT_CVL              = '@auth/SET_PARENT_CVL',
  UPDATE_DATABASE_PREFIX      = '@auth/UPDATE_DATABASE_PREFIX',
}

/* ── Si todavía despachas strings sueltos, expórtalos también ─────────── */
export const FORGOT_PASSWORD_REQUEST  = AuthActionTypes.FORGOT_PASSWORD_REQUEST;
export const FORGOT_PASSWORD_SUCCESS  = AuthActionTypes.FORGOT_PASSWORD_SUCCESS;
export const FORGOT_PASSWORD_ERROR    = AuthActionTypes.FORGOT_PASSWORD_ERROR;

export const SIGNUP_USER_SUCCESS      = AuthActionTypes.SIGNUP_USER_SUCCESS;

/* (las tres constantes de Google que ya tenías pueden seguir igual) */
export const LOGIN_USER_WITH_GOOGLE          = AuthActionTypes.LOGIN_USER_WITH_GOOGLE;
export const LOGIN_USER_WITH_GOOGLE_SUCCESS  = AuthActionTypes.LOGIN_USER_WITH_GOOGLE_SUCCESS;
export const LOGIN_USER_WITH_GOOGLE_FAILURE  = AuthActionTypes.LOGIN_USER_WITH_GOOGLE_FAILURE;
